import { useState } from "react";
import { toast } from "sonner";
import { Smartphone, Apple, Share, PlusSquare, MoreVertical } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useInstallPrompt } from "@/lib/pwa";

const Step = ({ n, children }) => (
  <li className="flex gap-3 items-start"><span className="w-6 h-6 shrink-0 rounded-full bg-cyan-500/20 border border-cyan-400/40 text-cyan-200 text-xs flex items-center justify-center font-mono">{n}</span><span className="text-sm text-slate-300">{children}</span></li>
);

const GUIDES = {
  android: { title: "Installa su Android", steps: [<>Apri questo sito con <b>Chrome</b></>, <>Tocca il menu <MoreVertical size={14} className="inline" /> in alto a destra</>, <>Scegli <b>“Installa app”</b> o <b>“Aggiungi a schermata Home”</b></>, <>Conferma: l'icona Aurora ON appare tra le tue app</>] },
  ios: { title: "Installa su iPhone / iPad", steps: [<>Apri questo sito con <b>Safari</b></>, <>Tocca <Share size={14} className="inline" /> <b>Condividi</b> in basso</>, <>Scorri e tocca <PlusSquare size={14} className="inline" /> <b>“Aggiungi a schermata Home”</b></>, <>Tocca <b>Aggiungi</b>: Aurora ON si apre come un'app</>] },
};

export const InstallButtons = () => {
  const { can, install, standalone } = useInstallPrompt();
  const [guide, setGuide] = useState(null);
  const android = async () => {
    if (standalone) return toast.success("Aurora ON è già installata");
    if (can && (await install())) return;
    setGuide("android");
  };
  const g = guide && GUIDES[guide];
  return (
    <>
      <div className="flex flex-col sm:flex-row gap-3 justify-center" data-testid="install-buttons">
        <button onClick={android} data-testid="btn-install-android"
          className="group flex items-center gap-3 rounded-2xl px-5 py-3 bg-[#0a1224]/90 border-2 border-emerald-400/60 shadow-[0_0_28px_rgba(16,185,129,.35)] hover:shadow-[0_0_40px_rgba(16,185,129,.6)] hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300">
          <Smartphone className="text-emerald-300" size={26} />
          <span className="text-left leading-tight"><span className="block text-[10px] font-mono uppercase tracking-widest text-emerald-300">Scarica APP per</span><span className="font-heading text-xl font-bold text-white">Android</span></span>
        </button>
        <button onClick={() => (standalone ? toast.success("Aurora ON è già installata") : setGuide("ios"))} data-testid="btn-install-ios"
          className="group flex items-center gap-3 rounded-2xl px-5 py-3 bg-[#0a1224]/90 border-2 border-sky-300/60 shadow-[0_0_28px_rgba(56,189,248,.35)] hover:shadow-[0_0_40px_rgba(56,189,248,.6)] hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300">
          <Apple className="text-sky-200" size={26} />
          <span className="text-left leading-tight"><span className="block text-[10px] font-mono uppercase tracking-widest text-sky-300">Scarica APP per</span><span className="font-heading text-xl font-bold text-white">iPhone · iOS</span></span>
        </button>
      </div>
      <Dialog open={!!g} onOpenChange={(o) => !o && setGuide(null)}>
        <DialogContent className="bg-[#0a1224] border-cyan-500/30" data-testid="install-guide-dialog">
          <DialogHeader><DialogTitle className="font-heading text-2xl">{g?.title}</DialogTitle><DialogDescription>Segui questi passaggi per installare Aurora ON.</DialogDescription></DialogHeader>
          <ol className="space-y-3 mt-2">{g?.steps.map((s, i) => <Step key={i} n={i + 1}>{s}</Step>)}</ol>
          <p className="text-xs text-slate-500 mt-2">Gratis, nessuno store necessario: l'app si aggiorna da sola.</p>
        </DialogContent>
      </Dialog>
    </>
  );
};
